<template>
  <div class="slv-icon">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <template v-if="iconName === 'krankenhaus'">
        <path d="M24 7.891v-7.995h-15.999v7.995h-8.001v24.109h32v-24.109zM8.001 30h-6v-20.109h6zM18.065 30h-4.004v-4h4.004zM22 30h-1.935v-6h-8.004v6h-2.061v-28.105h11.999zM30 30h-6v-20.109h6zM12.121 20.084h7.938v2h-7.938v-2zM15.063 13.001h2v-3h3.002v-2h-3.002v-3h-2v3h-3.003v2h3.003v3z" />
      </template>

      <template v-if="iconName === 'kranken-unfall1'">
        <path d="M29 32v-1.052c0-0 0-0 0-0.001 0-0.184-0.015-0.365-0.044-0.541l0.003 0.019-0.492-12.22-0.015-0.137c-0.316-1.728-1.488-3.124-3.051-3.751l-0.034-0.012-5.368-2.019v-1.054l1-2.020v-6.213c-0.002-1.656-1.344-2.998-3-3h-4c-1.656 0.002-2.998 1.344-3 3v6.237l1 1.999v1.051l-5.387 2.026c-1.439 0.583-2.463 1.912-2.596 3.494l-0.001 0.015-0.016 6.178v1.5l4 3v3.5h2v-3h10.484c0.003 0 0.006 0 0.009 0 1.109 0 2.096-0.518 2.734-1.326l0.006-0.007c0.469-0.592 0.753-1.35 0.753-2.175 0-0.299-0.037-0.589-0.107-0.866l0.005 0.024c-0.256-0.983-0.91-1.779-1.774-2.22l-0.020-0.009 1.527-6.637 1.029 0.387c0.933 0.376 1.622 1.185 1.824 2.17l0.003 0.019 0.492 12.209 0.015 0.137c0.014 0.073 0.022 0.156 0.022 0.241 0 0 0 0 0 0v0 1.052zM8.133 26.1l-2.133-1.6v-6.408c0.216-1.128 0.552-1.601 1.336-1.914l1.547-0.582zM21.727 15.073l-1.593 6.927h-1.915l1.534-7.669zM10.074 27l0.87-12.179 1.254-0.472 1.974 12.651zM14 12.921v-2.232h-0.037l-0.963-1.925v-5.764c0.001-0.552 0.448-0.999 1-1h4c0.552 0.001 0.999 0.448 1 1v5.745l-0.962 1.944h-0.038v2.212l-1.82 9.099h-0.764zM21.663 26.428c-0.276 0.35-0.7 0.572-1.175 0.572-0.001 0-0.002 0-0.004 0h-4.288l-0.468-3h4.633c0.020-0.001 0.043-0.001 0.066-0.001 0.708 0 1.307 0.465 1.508 1.106l0.003 0.011c0.031 0.114 0.048 0.244 0.048 0.379 0 0.354-0.122 0.679-0.326 0.936l0.002-0.003z" />
      </template>

      <template v-if="iconName === 'serviceleistungen'">
        <path d="M8 7h6v2h-6v-2zM4 2h14v8h8v5.001h2v-6.415l-8.586-8.586h-17.414v32.001h13v-2h-11zM20 3.414l4.586 4.586h-4.586zM25.5 17c-1.134 0.002-2.178 0.385-3.012 1.027l0.012-0.009c-0.827-0.63-1.874-1.009-3.009-1.009-2.757 0-4.992 2.235-4.992 4.992 0 1.359 0.543 2.591 1.424 3.491l-0.001-0.001 6.073 6.51h1.011l6.372-6.873c0.698-0.843 1.121-1.936 1.122-3.127v-0c-0.003-2.76-2.24-4.997-5-5h-0zM27.867 23.818l-5.369 5.789-5.133-5.501c-0.541-0.541-0.875-1.289-0.875-2.115 0-1.652 1.339-2.991 2.991-2.991 0.904 0 1.714 0.401 2.263 1.034l0.003 0.004 0.754 0.862 0.752-0.862c0.551-0.637 1.36-1.038 2.262-1.038 1.648 0 2.985 1.336 2.985 2.985 0 0.005 0 0.011-0 0.016v-0.001c0 0.001 0 0.002 0 0.003 0 0.689-0.238 1.322-0.637 1.822l0.005-0.006zM8 12.999h14v2h-14v-2zM8 17h4v2h-4v-2zM8 21h4v2h-4v-2zM8 25h4v2h-4v-2z" />
      </template>
    </svg>
  </div>

</template>

<script>
export default {
  name: 'slv-icon',

  props: {
    iconName: {
      type: String
    }
  }
};
</script>

<style lang="scss">
.slv-icon {
  cursor: pointer;

  svg {
    fill: currentColor;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/slv-icon.vue